import PieChartComponent from '../utils/PieChartComponent';
import { getTotalsGraph } from '../DiscipleshipCharts';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';

export const DiscipleshipOpenGroupsCharts = ({
  openGroupsDataByLeadershipTypeForPieChart,
  openGroupsDataByGenderForPieChart,
  openGroupsDataByModalityForPieChart,
  openGroupsDataByStatusForBarChart,
}) => {
  return (
    <>
      <div className="totalLabels">
        Total de grupos: {getTotalsGraph(openGroupsDataByLeadershipTypeForPieChart)}
      </div>
      <div className="chartSection">
        <PieChartComponent
          title="Por tipo de grupo"
          data={openGroupsDataByLeadershipTypeForPieChart}
          pieType="group"
        />
        <PieChartComponent
          title="Por género"
          data={openGroupsDataByGenderForPieChart}
          pieType="group"
        />
        <PieChartComponent
          title="Por modalidad"
          data={openGroupsDataByModalityForPieChart}
          pieType="group"
        />
        <div className="graphic">
          <h3>Por estado</h3>
          {openGroupsDataByStatusForBarChart?.length > 0 ? (
            <BarChart width={360} height={250} data={openGroupsDataByStatusForBarChart}>
              <CartesianGrid strokeDasharray="3 3" stroke="#eee" />
              <XAxis dataKey="name" tick={{ fontSize: 12 }} />
              <YAxis tick={{ fontSize: 12 }} width={40} />
              <Tooltip />
              <Legend wrapperStyle={{ fontSize: 12 }} />
              <Bar
                dataKey="cantidad"
                name="Cantidad"
                fill="#fc9133"
                radius={[6, 6, 0, 0]}
                isAnimationActive={false}
              />
            </BarChart>
          ) : (
            <div className="chart-empty">No hay datos para mostrar</div>
          )}
          <p className="chart-note">
            <strong>Abiertos:</strong> grupos activos que reciben más personas.
            <br />
            <strong>Cerrados:</strong> grupos activos que no reciben más personas.
          </p>
        </div>
      </div>
    </>
  );
};
